module.exports = __webpack_public_path__ + "static/bugbear-2162beda98354120e9e260944d461606.jpg";